import api from '../api/index'
// import utils from '../../utils/raceutils'

const state = {
  teams: {},
  team: {},
  sortedTeams: [],
}

const mutations = {
  setTeams (state, payload) {
    state.teams = payload
  },
  setTeam (state, payload) {
    state.team = payload
  },
  setSortedTeams (state, payload) {
    state.sortedTeams = payload
  }
}

const actions = {

}

const getters = {
  teams: (state, context) => {
    return state.teams
  },
  team: state => {
    return state.team
  },
  sortedTeams: state => {
    return state.sortedTeams.map(id => state.teams[id])
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/teams.js